export const TEMPLATE_VALUE = {
  NONE: {VALUE: 'None', NAME: 'None'},
  GLOBAL: {VALUE: 'Standard (global)', NAME: 'Standard (global)'}
}